import { jsxs as t, jsx as o } from "react/jsx-runtime";
const r = ({ className: C }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "41",
    height: "41",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: C,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M31.5 28.7994L31.6049 28.7236C33.3681 27.4507 34.2496 26.8142 34.9582 27.1215C35.6667 27.4288 35.6667 28.4477 35.6667 30.4854V31.6257C35.6667 33.6633 35.6667 34.6822 34.9582 34.9895C34.2496 35.2968 33.3681 34.6603 31.6049 33.3874L31.5 33.3117M24.8333 36.8888H25.6667C28.4165 36.8888 29.7915 36.8888 30.6457 36.1413C31.5 35.3939 31.5 34.1908 31.5 31.7847V30.3263C31.5 27.9202 31.5 26.7171 30.6457 25.9697C29.7915 25.2222 28.4165 25.2222 25.6667 25.2222H24.8333C22.0835 25.2222 20.7085 25.2222 19.8543 25.9697C19 26.7171 19 27.9202 19 30.3263V31.7847C19 34.1908 19 35.3939 19.8543 36.1413C20.7085 36.8888 22.0835 36.8888 24.8333 36.8888Z",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M34 20.2458V13.2662C34 10.4401 34 9.02707 33.5534 7.89851C32.8354 6.0842 31.317 4.65309 29.392 3.97639C28.1946 3.55546 26.6954 3.55546 23.697 3.55546C18.4497 3.55546 15.826 3.55546 13.7306 4.29209C10.3619 5.47632 7.70469 7.98076 6.44823 11.1558C5.66667 13.1308 5.66667 15.6036 5.66667 20.5492V24.7977C5.66667 29.9205 5.66667 32.482 7.0795 34.2608C7.4843 34.7705 7.96437 35.2229 8.50512 35.6045C9.77216 36.4984 11.4134 36.7922 14 36.8888",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.66536 20.2222C5.66536 17.1539 8.15267 14.6666 11.2209 14.6666C12.3306 14.6666 13.6388 14.861 14.7176 14.572C15.6762 14.3151 16.425 13.5664 16.6818 12.6078C16.9709 11.5289 16.7765 10.2207 16.7765 9.11106C16.7765 6.04281 19.2638 3.5555 22.332 3.5555",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  r as VideoFileIcon
};
